import type { Sprint } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/sprints';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda';

export const getSprintName = (sprintId: string | null | undefined, sprints: Sprint[]): string => {
	const sprint = sprints.find(({ id }: Sprint) => id === sprintId);

	return isDefined(sprint) ? sprint.title : '';
};
